import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { NbsUser } from 'src/app/models/entities/nbs-user';
import { VNbsUser } from 'src/app/models/entities/v-nbs-user';
import { NbsUserService } from 'src/app/services/nbs-user.service';

@Component({
  selector: 'app-nbs-user',
  templateUrl: './nbs-user.component.html',
  styleUrls: ['./nbs-user.component.css']
})
export class NbsUserComponent implements OnInit {

  destroy$ = new Subject<void>();
  users$: Observable<VNbsUser[]>;
  roles: any[];
  form: FormGroup
  addModal: boolean;
  updateModal: boolean;
  deleteModal: boolean;
  deleteUserId: number;

  @ViewChild('dt', { static: false }) dt: any;
  constructor(private userService: NbsUserService, private formBuilder: FormBuilder, private toastrService: ToastrService) {
    this.roles = [{ value: 1, name: "Admin" }, { value: 2, name: "Kullanıcı" }]
  }

  ngOnInit(): void {
    this.getList();
    this.createForm();
  }
  getList() {
    this.users$ = this.userService.getList().pipe(map(result => result.data));
  }

  createForm() {
    this.form = this.formBuilder.group({
      id: 0,
      fullName: ["", Validators.required],
      userName: ["", Validators.required],
      password: ["", Validators.required],
      roleId: ["", Validators.required],
      isActive: true
    })
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showAddModal() {
    this.addModal = true;
  }

  showUpdateModal(userId: number) {
    this.updateModal = true;
    this.userService.getById(userId).pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.form.patchValue(result.data);
    })
  }

  showDeleteModal(userId: number) {
    this.deleteModal = true;
    this.deleteUserId = userId;
  }

  deleteUser() {
    this.userService.delete(this.deleteUserId).pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.toastrService.success("Kullanıcı başarıyla silindi.", "Başarılı");
      this.deleteModal = false;
      this.getList();
    })
  }

  save(proccess: string) {
    if (this.form.valid) {
      const user: NbsUser = this.form.getRawValue();
      user.userId = this.userService.getUserId();
      if (proccess == "Add") {
        this.userService.add(user).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.toastrService.success("Kullanıcı başarıyla sisteme eklendi.", "Başarılı");
          this.addModal = false;
          this.getList();
        },
          er => {
            this.toastrService.error(er.error.message, "Hata!");
          }
        )
      }
      else if (proccess == "Update") {
        this.userService.update(user).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.toastrService.success("Kullanıcı başarıyla güncellendi.", "Başarılı");
          this.updateModal = false;
          this.getList();
        },
          er => {
            this.toastrService.error(er.error.message, "Hata!");
          }
        )
      }
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();
  }


}
